import ReactPortableText from 'react-portable-text'

import './portableText.scss'

export default function PortableText({
  content,
}: {
  readonly content: object[]
}) {
  return (
    <div className="portable-text-wrapper" data-testid="react-portable-text">
      <ReactPortableText content={content} />
    </div>
  )
}
